"use strict";

/**
 * Limit the file size of a file input
 */

$.onmount("[data-behavior~=file-size-limit]", function() {
  const $input = $(this);
  const maxSizeInBytes = $input.data("max-size") || 4 * 1024 * 1024; // Default to 4MB
  const maxSizeText = $input.data("max-size-text") || "4MB";

  $input.on("change", function() {
    const files = this.files;
    if (!files) return;

    const maxCount = $input.data("max-count");
    if (maxCount && files.length > maxCount) {
      let message = $input.data("max-count-error-message") || `You can only upload a maximum of ${maxCount} files.`;
      message = message.split("%{max_count}").join(maxCount);

      $.flash("warning", message);
      $input.val(""); // Clear the input
      return;
    }

    for (let i = 0; i < files.length; i++) {
      if (files[i].size > maxSizeInBytes) {
        let message = $input.data("max-size-error-message") || `File exceeds the maximum size of ${maxSizeText}.`;
        message = message.split("%{max_size}").join(maxSizeText);

        $.flash("warning", message);
        $input.val(""); // Clear the input
        break;
      }
    }
  });
});
